import * as types from '../types/google-address-verify-types';
import googlePlacesInstance from '../googlePlacesInstance';

const noResultsError = 'ZERO_RESULTS';

export const fetchAddressPredictions = (query) => {
    return (dispatch) => {
        dispatch(fetchingAddressPredictions(query));
        googlePlacesInstance.getPlacePredictions(query)
            .then((result) => dispatch(setAddressPredictions(result)))
            .catch((error) => {
                if(error === noResultsError) {
                    dispatch(setHasSeenError(true));
                } else {
                    dispatch(setApiFailureState(true));
                }
                dispatch(failedFetchingAddressPredictions(error));
            });
    };
};

export const fetchingAddressPredictions = (query) => {
    return {
        type: types.FETCHING_ADDRESS_PREDICTIONS,
        query: query
    };
};

export const setPendingAddressPredictionsFetch = (isPending) => {
    return {
        type: types.PENDING_ADDRESS_PREDICTIONS_FETCH,
        isPending: isPending
    }
};

export const setAddressPredictions = (predictions) => {
    return {
        type: types.SET_ADDRESS_PREDICTIONS,
        addressPredictions: predictions
    };
};

export const setHasSeenError = (hasSeen) => {
    return {
        type: types.SET_HAS_SEEN_ERROR,
        hasSeen: hasSeen
    }
};

export const failedFetchingAddressPredictions = (error) => {
    return {
        type: types.FAILED_FETCHING_ADDRESS_PREDICTIONS,
        error: error
    };
};

export const clearAddressPredictions = () => {
    return {
        type: types.CLEAR_ADDRESS_PREDICTIONS
    };
};

export const clearAddressInput = () => {
    return {
        type: types.CLEAR_ADDRESS_INPUT
    };
};

export const updateAddressInput = (text) => {
    return {
        type: types.UPDATE_ADDRESS_INPUT,
        text: text
    };
};

export const setActivePrediction = (index) => {
    return {
        type: types.SET_ACTIVE_PREDICTION,
        index: index
    };
};

export const selectPrediction = (prediction) => {
    return (dispatch) => {
        dispatch(fetchingAddressDetails(prediction.placeId));
        googlePlacesInstance.getPlaceDetails(prediction.placeId)
            .then((result) => {
                if(!result.isValid){
                    dispatch(setHasSeenError(true));
                }
                dispatch(selectAddress(result));
                if(!result.hasValidCity || !result.hasValidZip){
                    dispatch(setApiFailureState(true));
                }
            })
            .catch((error) => dispatch(failedFetchingAddressDetails(error)));
    }
};

export const fetchingAddressDetails = (placeId) => {
    return {
        type: types.FETCHING_ADDRESS_DETAILS,
        placeId: placeId
    };
};

export const failedFetchingAddressDetails = (error) => {
    return {
        type: types.FAILED_FETCHING_ADDRESS_DETAILS,
        error: error
    };
};

export const selectAddress = (address) => {
    return (dispatch) => {
        dispatch(updateAddressInput(address.formattedAddress));
        dispatch(setSelectedAddress(address));
    };
};

export const setSelectedAddress = (address) => {
    return {
        type: types.SET_SELECTED_ADDRESS,
        selectedAddress: address
    };
};

export const forceAddressValidation = (shouldForceValidation) => {
    return {
        type: types.FORCE_ADDRESS_VALIDATION,
        shouldForceValidation: shouldForceValidation
    };
};

export const setShouldDisplayComponent = (shouldDisplay) => {
    return {
        type: types.SET_SHOULD_DISPLAY_COMPONENT,
        shouldDisplay: shouldDisplay
    };
};

export const setApiFailureState = (isFailureState) => {
    return {
        type: types.SET_API_FALIURE_STATE,
        isFailureState: isFailureState
    };
};
